import { useEffect } from "react";

export const GlobalIOSButtonFix = () => {
    useEffect(() => {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

        if (!isIOS) return;

        const handleTap = (e: Event) => {
            const target = e.target as HTMLElement;
            if (target.tagName === "BUTTON" && target.getAttribute("type") === "submit") {
                setTimeout(() => (target as HTMLButtonElement).blur(), 100);
            }
        };

        document.addEventListener("click", handleTap, true);

        return () => {
            document.removeEventListener("click", handleTap, true);
        };
    }, []);

    return null;
}
